export default {"src":"/_next/static/media/logo-tdg-mobile.efcc2c71.svg","height":17,"width":180,"blurWidth":0,"blurHeight":0};